import React from "react";
import Meta from "./../components/Meta";
import HeroSection3 from "./../components/HeroSection3";
import StatsSection from "./../components/StatsSection";
import TeamBiosSection from "./../components/TeamBiosSection";
import CtaSection from "./../components/CtaSection";

function ContactPage(props) {
  return (
    <>
      <Meta title="Contact Us" description="We'd love to hear from you! " />

      <HeroSection3
        title={
          <>
            Contact us<span className="font-light"></span>
          </>
        }
        //subtitle="A passionate team who are here to help you have best experience exchanging books."
        strapline=""
        size="md"
        bgColor="bg-white"
        bgImage=""
        bgImageOpacity={1}
        textColor=""
        //src = "/images/happyreader.jpg"
        //leftImage = "/images/booksgrass.jpg" //h = 800 w = 1280
       // rightImage = "/images/earth2.jpg"//h = 800 q=90 w=600
       //leftImage = "/images/earth1.jpg" //h = 800 w = 1280
       // rightImage = "/images/share1.jpg"//h = 800 q=90 w=600
        //leftImage="https://images.unsplash.com/photo-1542744173-8e7e53415bb0?crop=entropy&fit=crop&h=800&w=1280"
        //rightImage="https://images.unsplash.com/photo-1554232456-8727aae0cfa4?crop=entropy&fit=crop&h=800&q=80&w=600"
      />
  
    </>
  );
}

export default ContactPage;
